// extracted by mini-css-extract-plugin
export default {"wrap":"ProductGroupsListComponent_wrap__jApi4"};